let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8A9gt")).then(() => parcelRequire('8Gzfx'));